// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__1xYIn","errorLogs":"styles_errorLogs__Ty48T"};